module.exports = __webpack_public_path__ + "img/connection4.35be3ad0.png";